import { Reveal } from "./Reveal";
import { scrollToId } from "../data/site";

export default function About() {
  return (
    <section id="about" className="bg-[#F4F4F6] text-zinc-900 py-20 lg:py-28 scroll-mt-16">
      <div className="container-x grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <Reveal>
          <div className="font-tech text-xs uppercase tracking-[0.25em] text-[#FF2A2A] font-semibold mb-4">
            ABOUT THE STUDIO
          </div>
          <h2
            data-testid="about-headline"
            className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase tracking-tight leading-[0.95] mb-6"
          >
            From sketch to street — a complete visual studio
          </h2>
          <p data-testid="about-content-paragraph" className="text-zinc-600 text-sm sm:text-base leading-relaxed mb-5">
            VIC WRAP STUDIO combines graphic design, creative concept development
            and hands-on installation experience to deliver complete visual
            solutions for businesses, vehicles, homes and commercial properties
            across Melbourne.
          </p>
          <p className="text-zinc-600 text-sm sm:text-base leading-relaxed mb-8">
            Because the same team designs, prints and installs your project,
            nothing gets lost between the screen and the street. What we mock up
            is what we deliver — clean, precise and built to last.
          </p>

          <div className="grid grid-cols-3 gap-6 border-t border-black/10 pt-8 mb-8">
            <div data-testid="about-stat-years-experience">
              <div className="font-display text-4xl font-extrabold">12+</div>
              <div className="font-tech text-[10px] uppercase tracking-[0.2em] text-zinc-500">Years Combined Experience</div>
            </div>
            <div>
              <div className="font-display text-4xl font-extrabold">70+</div>
              <div className="font-tech text-[10px] uppercase tracking-[0.2em] text-zinc-500">Projects Completed</div>
            </div>
            <div>
              <div className="font-display text-4xl font-extrabold text-[#FF2A2A]">6</div>
              <div className="font-tech text-[10px] uppercase tracking-[0.2em] text-zinc-500">Specialist Services</div>
            </div>
          </div>

          <blockquote data-testid="about-founder-note" className="border-l-4 border-[#FF2A2A] pl-5 text-zinc-700 italic text-sm leading-relaxed mb-8">
            "Every job that leaves the studio carries our name. That's why we
            obsess over the edges nobody else will ever notice."
            <span className="block not-italic font-tech text-[10px] uppercase tracking-[0.2em] text-zinc-500 mt-3">
              — The VIC WRAP STUDIO Team
            </span>
          </blockquote>

          <button data-testid="about-quote-button" onClick={() => scrollToId("quote")} className="btn-dark">
            WORK WITH US — FREE QUOTE
          </button>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="relative pb-14 pr-6">
            <div className="rounded-2xl overflow-hidden border border-black/10 shadow-2xl">
              <img
                src="/images/about-main.webp"
                alt="vicwrap studio installer applying carbon fibre vinyl to a car fender"
                loading="lazy"
                className="w-full h-[380px] sm:h-[460px] object-cover"
              />
            </div>
            <div className="absolute -bottom-0 -right-0 w-56 sm:w-72 rounded-2xl overflow-hidden border-4 border-[#F4F4F6] shadow-xl">
              <img
                src="/images/about-secondary.webp"
                alt="Toyota C-HR before and after vehicle wrap — VIC WRAP STUDIO"
                loading="lazy"
                className="w-full h-40 sm:h-48 object-cover"
              />
            </div>
            <div className="absolute top-6 -left-2 bg-gradient-to-br from-[#FF2A2A] to-[#FF6B00] text-white rounded-xl px-5 py-4 shadow-[0_10px_30px_rgba(255,80,0,0.4)] rotate-[-3deg]">
              <div className="font-display text-2xl font-extrabold leading-none">MELBOURNE</div>
              <div className="font-tech text-[9px] uppercase tracking-[0.25em] text-white/85 mt-1">Design · Print · Install</div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
